import React from 'react'
import './style.css'

const Header = () => {
  return (
    <header className='header-content'>
      <h2>Simple CRUD with REACT</h2>
    </header>
  )
}

export default Header